export default __webpack_public_path__ + "static/media/emptyBookmark.bb02a291.svg";